import { type WhiteboardInternalModalProps } from '../whiteboard-bridge-api-type';

export type ModalHandler = (options: WhiteboardInternalModalProps) => Promise<void>;

export class WhiteboardInternalModalService {
	#modalHandler: ModalHandler = async () => {};
	#closeHandler: () => void = () => {};

	registerModalHandler(modalHandler: ModalHandler) {
		this.#modalHandler = modalHandler;
	}

	registerCloseHandler(closeHandler: () => void) {
		this.#closeHandler = closeHandler;
	}

	showModal(options: WhiteboardInternalModalProps) {
		return this.#modalHandler(options);
	}

	closeModal() {
		this.#closeHandler();
	}
}
